'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import React, { useState } from 'react';
import { Input } from 'ui';
import { qsStringify } from 'utils';
import { generateButterBlogLink } from '~/components/Links/ButterBlogLink';

interface Props {}

const BlogSearch: React.FC<Props> = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const [searchText, setSearchText] = useState(searchParams?.get('q') || '');

  const handleFormSubmit: React.FormEventHandler = e => {
    e.preventDefault();
    router.push(
      generateButterBlogLink({ search: true }) +
        qsStringify({
          q: searchText,
        }),
    );
  };
  return (
    <form className="w-full md:ml-2 md:w-64" onSubmit={handleFormSubmit}>
      <Input
        placeholder="Search blog"
        type="search"
        className="border-l-none md:border-r-none rounded-l-none md:rounded-l md:rounded-r-none md:border-l"
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
      />
    </form>
  );
};

export default BlogSearch;
